export const refElements = (
	fromEl: HTMLInputElement,
	id: string | undefined,
): (ChildNode & {
	readonly dataset?: DOMStringMap;
})[] => {
	const result = [];
	let el: (ChildNode & { readonly dataset?: DOMStringMap }) | null = fromEl;
	while ((el = el.nextSibling)) {
		if (el.dataset && el.dataset.lazyEnd === id) {
			break;
		}
		result.push(el);
	}

	return result;
};
